export default class Placeholder {
  static name_person = "e.g. John Doe"
  static name_book = "e.g. Laskar Pelangi"
  static name_category = "e.g. Fiksi"
  static name_publisher = "e.g. AAA Group / PT barabaca"
  static name_news = "e.g. Weekly Announcement"
  static name_media = "e.g. Tinta & Ide: Dari Coretan sampai Jadi Buku"
  static password = "Insert password here"
  static password_old = "Insert old password here"
  static password_new = "Insert new password here"
  static password_confirm = "Confirm your password"
  static admin_role = "Select a role"
  static select_author = "Select author(s)"
  static select_publisher = "Select a publisher"
  static select_illustrator = "Select an illustrator"
  static select_agency = "Select a literary agency"
  static select_translator = "Select a translator"
  static select_categories = "Select category(s)"
  static select_available_languages = "Select language(s)"
  static phone = "e.g. +621111222233"
  static email = "e.g. example@email.com"
  static website = "www.example.com"
  static address = "e.g. Jl. Mawar No. 15, RT 005/RW 002, Kel. Mekar, Kec. Kencana, Kota Agung, 12345 or other shorter version"
  static biography = "Insert biography here"
  static description = "Insert description here"
  static language = "e.g. Indonesia, English, Spanish, French"
  static initial_language = "e.g. Indonesia / English / Spanish"
  static facebook = "e.g. https://www.facebook.com/bukugpu"
  static instagram = "e.g. https://www.instagram.com/bukugpu/"
  static tiktok = "e.g. https://www.tiktok.com/@bukugpu.id"
  static twitter = "e.g. https://x.com/bukugpu"
  static youtube = "e.g. https://www.youtube.com/@gramediabooks"
  static website = "e.g. https://example.com/"
  static video_embed = "e.g. https://www.youtube.com/watch?v=w9WBlURy5yQ"
  static isbn = "e.g. 978-0-306-40615-7"
  static total_page = "e.g. 224"
  static summary_news = "Insert news summary here"
  static meta_title = "Insert title to display on web search results"
  static meta_description = "Insert description to display on web search results"


  static translated = {
    name_person: "e.g. John Doe (Translated Version)",
    name_book: "e.g. The Rainbow Troops (Translated Version)",
    name_category: "e.g. Fiction (Translated Version)",
    name_news: "e.g. Weekly Announcement (Translated version)",
    name_media: "e.g. Ink & Ideas: From Drafts to Published Works (Translated Version)",
    biography: "Insert biography here (Translated Version)",
    description: "Insert description here (Translated Version)",
    summary_news: "Insert news summary here (Translated Version)",
  }
}